import { render } from "./Publish2View.vue?vue&type=template&id=2575ee10&scoped=true"
import script from "./Publish2View.vue?vue&type=script&lang=js"
export * from "./Publish2View.vue?vue&type=script&lang=js"

import "./Publish2View.vue?vue&type=style&index=0&id=2575ee10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2575ee10"]])

export default __exports__